import React from 'react';
import SyntaxHighlight from 'components/SyntaxHighlight';
import CopyToClipboardButton from 'components/CopyToClipboardButton';

import './script-instructions.less';

const banner = 'Extellio';
const host = 'https://script.extellio.com/'; // TODO: get config from state

export const JavascriptCode = ({ id, title }) => {
  const text = `/* ${banner}${title ? ` - ${title}` : ''} */
(function(d,h,s){
s=d.createElement('script');
s.async=1;s.src=h;
d.getElementsByTagName('head')[0].appendChild(s);
})(document,'${host}${id}.min.js');`;
  return (
    <div className="script-code">
      <SyntaxHighlight language="javascript">{text}</SyntaxHighlight>
      <CopyToClipboardButton textToCopy={text} type="link" />
    </div>
  );
};

export const HTMLCode = ({ id, title }) => {
  const text = `<!-- ${banner}${title ? ` - ${title}` : ''} -->
<script async src="${host}${id}.min.js"></script>`;
  return (
    <div className="script-code">
      <SyntaxHighlight language="html">{text}</SyntaxHighlight>
      <CopyToClipboardButton textToCopy={text} type="link" />
    </div>
  );
};
